import { IApplicationState } from '../../types/redux';

export const getHasFutureObjects = (state: IApplicationState): boolean => {
  return state.newbuilding.hasFutureObjects;
};
